module.exports = __webpack_public_path__ + "static/media/06-09.ef1fff6c.png";